import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { GetPatientDoctorNotes } from "Services/API/Patients.service";

// Patient-wide twin of useVisitPdfs: same pagination contract, same row shape
// (the backend reuses the per-visit enrichment), so the Visit Notes PDFs table
// renders it unchanged.
export const usePatientPdfs = (patientId, initialPage = 1, perPage = 10) => {
  const [page, setPage] = useState(initialPage);

  const { data, isLoading, isError, error, refetch } = useQuery(
    ["patientPdfs", patientId, page],
    () => GetPatientDoctorNotes(patientId, page, perPage),
    {
      enabled: !!patientId,
      keepPreviousData: true,
    },
  );

  const pagination = data?.pagination;

  const goToNextPage = useCallback(() => {
    if (pagination?.hasNext) setPage((prev) => prev + 1);
  }, [pagination?.hasNext]);

  const goToPreviousPage = useCallback(() => {
    if (pagination?.hasPrevious) setPage((prev) => Math.max(prev - 1, 1));
  }, [pagination?.hasPrevious]);

  return {
    pdfs: data?.data || [],
    pagination: data?.pagination || {},
    isLoading,
    isError,
    error,
    page,
    hasNext: pagination?.hasNext ?? false,
    hasPrevious: pagination?.hasPrevious ?? false,
    goToNextPage,
    goToPreviousPage,
    setPage,
    refetch,
  };
};
